import { render, staticRenderFns } from "./tePaymentDtl.vue?vue&type=template&id=2968db6e&scoped=true&"
import script from "./tePaymentDtl.vue?vue&type=script&lang=js&"
export * from "./tePaymentDtl.vue?vue&type=script&lang=js&"
import style0 from "./tePaymentDtl.vue?vue&type=style&index=0&id=2968db6e&prod&lang=scss&scoped=true&"
import style1 from "./tePaymentDtl.vue?vue&type=style&index=1&id=2968db6e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2968db6e",
  null
  
)

export default component.exports